import { Pipe, PipeTransform } from '@angular/core';

import { ConfigService } from '../../../../core';
import { ConfigEmpresa, createNomeCliente, isIdentificacaoClienteNome } from '../../../configuracoes/app/empresa';
import { isTipoPessoaCentralCompras } from '../../tipo';

@Pipe({
    name: 'clienteNome'
})
/** Pipe utilizado para exibir o nome do cliente conforme forma de identificação configurada pela empresa */
export class ClienteNomePipe implements PipeTransform {
    configEmpresa: ConfigEmpresa;

    constructor(private configService: ConfigService) {
        this.configEmpresa = this.configService.getEmpresa();
    }

    /** Retorna o nome primário do cliente conforme a identificação do cliente pela empresa selecionada na configuração da Empresa */
    transform(nome: string, nomeFantasia: string, codigoIntegracaoErp: string = null, tipoPessoa: number = null): string {
        let codigo = '';
        // Somente adiciona o código quando informado e a identificação for pelo nome
        if (codigoIntegracaoErp) { // && isIdentificacaoClienteNome(this.configEmpresa.identificacaoCliente)
            codigo = `${codigoIntegracaoErp} - `;
        }
        return `${codigo}${createNomeCliente(this.configEmpresa.identificacaoCliente, nome, nomeFantasia)} ${isTipoPessoaCentralCompras(tipoPessoa) ? '(CC)' : ''}`;
    }
}
